module.exports = __webpack_public_path__ + "static/media/escpLogo.99891f0b.png";